import { get, post } from './client';

export interface WorkspaceStatus {
  connected: boolean;
  scopes: string[];
  expires_at: string | null;
}

export interface CalendarSyncResult {
  synced: number;
  updated: number;
  total_events: number;
}

export interface CalendarEvent {
  id: string;
  name: string;
  start_date: string | null;
  start_time: string;
  end_time: string;
  location: string;
  attendees: number;
  status: string;
}

export interface EmailItem {
  id: string;
  subject: string;
  from: string;
  date: string;
  snippet: string;
  labels: string[];
}

export async function getWorkspaceStatus(): Promise<WorkspaceStatus> {
  return get<WorkspaceStatus>('/api/user/google-workspace/status');
}

export async function disconnectWorkspace(): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>('/api/user/google-workspace/disconnect', {});
}

export async function syncCalendar(teamId: string): Promise<CalendarSyncResult> {
  return post<CalendarSyncResult>(`/api/teams/${teamId}/google-workspace/sync-calendar`, {});
}

export async function getTodayCalendarEvents(
  teamId: string
): Promise<{ events: CalendarEvent[]; connected: boolean }> {
  return get<{ events: CalendarEvent[]; connected: boolean }>(
    `/api/teams/${teamId}/google-workspace/calendar/today`
  );
}

export async function getRecentEmails(
  teamId: string,
  maxResults = 20
): Promise<{ emails: EmailItem[]; connected: boolean }> {
  return get<{ emails: EmailItem[]; connected: boolean }>(
    `/api/teams/${teamId}/google-workspace/emails?max_results=${maxResults}`
  );
}

export interface DashboardGmail {
  connected: boolean;
  address: string | null;
  inbox_count: number | null;
  unread_count: number | null;
  messages: { id: string; from: string; subject: string; date: string }[];
  error: string | null;
}

export interface DashboardCalendarEvent {
  id: string;
  title: string;
  start: string | null;
  end: string | null;
  location: string;
  html_link: string | null;
}

export interface DashboardCalendar {
  connected: boolean;
  upcoming_count: number;
  events: DashboardCalendarEvent[];
  error: string | null;
}

export interface DashboardSummary {
  connected: boolean;
  gmail: DashboardGmail;
  calendar: DashboardCalendar;
}

export async function getDashboardSummary(teamId: string): Promise<DashboardSummary> {
  return get<DashboardSummary>(
    `/api/teams/${teamId}/google-workspace/dashboard-summary`
  );
}
